import { z } from "zod";

import { ordinal } from "@features/data-export/components/schedule-configurator/utils";
import {
  ScheduleTimeFrameFrequency,
  WeekDay,
} from "@north-beam/nb-client-side/nb-api-graphql-generated";
import { daysOfTheMonth, lastDayOfTheMonth } from "@north-beam/nb-common";

export const frequencyOptions: {
  value: ScheduleTimeFrameFrequency;
  label: string;
}[] = [
  { value: ScheduleTimeFrameFrequency.DAILY, label: "Daily" },
  { value: ScheduleTimeFrameFrequency.WEEKLY, label: "Weekly" },
  { value: ScheduleTimeFrameFrequency.MONTHLY, label: "Monthly" },
] as const;

export const monthlyScheduleDayOptions: {
  value: typeof lastDayOfTheMonth | (typeof daysOfTheMonth)[number];
  label: string;
}[] = [
  { value: lastDayOfTheMonth, label: "Last day of the month" },
  ...daysOfTheMonth.map((day) => ({
    value: day,
    label: ordinal(day),
  })),
] as const;

const baseScheduleTimeFrame = z.object({
  time: z.string().time({ precision: 0 }),
});

export const dailyScheduleTimeFrame = baseScheduleTimeFrame.extend({
  frequency: z.literal(ScheduleTimeFrameFrequency.DAILY),
});

export const weeklyScheduleTimeFrame = baseScheduleTimeFrame.extend({
  frequency: z.literal(ScheduleTimeFrameFrequency.WEEKLY),
  weekDay: z.nativeEnum(WeekDay),
});

export const monthlyScheduleTimeFrame = baseScheduleTimeFrame.extend({
  frequency: z.literal(ScheduleTimeFrameFrequency.MONTHLY),
  day: z.union([z.literal(lastDayOfTheMonth), z.number().min(1).max(28)]),
});

export const scheduleTimeFrameSchema = z.discriminatedUnion("frequency", [
  dailyScheduleTimeFrame,
  weeklyScheduleTimeFrame,
  monthlyScheduleTimeFrame,
]);
